import React from 'react'
import { useTranslation } from 'react-i18next'

import { CategorySlide } from '@src/components/BusinessSegments/CategorySlide'
import { SegmentCategoriesContainer } from '@src/components/BusinessSegments/CategorySlide.styles'
import { Carousel } from '@src/components/Carousel'
import { TextClamp } from '@src/components/Text/Clamp'
import { BusinessSegment, Cuisine } from '@src/graphql-types'

import { IconButton } from '../Button/IconButton'
import {
  HeroContainer,
  OutletContainer,
  SliderArrowsContainer,
  Description,
  BusinessSegmentCategoriesHeader,
} from '../FeaturedOutlets/FeaturedOutlets.styles'
import { useMarketplace } from '../../hooks/useMarketplace'
import { useBottomSheetStack } from '../../hooks/useBottomSheetStack/useBottomSheetStack'

type Props = {
  segment: Pick<BusinessSegment, 'id' | 'name' | 'showName' | 'description'> & {
    cards: Cuisine[]
  }
}

export const BusinessSegmentCategories: React.FC<Props> = ({ segment }) => {
  const { t } = useTranslation('navigation')
  const { categories } = useMarketplace()
  const { categoriesBottomSheetController } = useBottomSheetStack()

  const segmentsToUse =
    segment.cards.length === 0
      ? categories.filter(
          category => category.id !== 'deals' && category.id !== 'featured'
        )
      : segment.cards

  // remove categories not on the marketplace (as outlets may have been removed)
  const segmentCategories = segmentsToUse.filter(card =>
    categories.find(category => category.id === card.id)
  )

  const circleButtonLeftClassName = `${segment.id}-segment-left`
  const circleButtonRightClassName = `${segment.id}-segment-right`
  return (
    <>
      {segmentCategories?.length > 0 && (
        <OutletContainer>
          <HeroContainer>
            <BusinessSegmentCategoriesHeader
              onClick={() => categoriesBottomSheetController.open()}
            >
              {segment.showName && segment.name}
            </BusinessSegmentCategoriesHeader>
            <SliderArrowsContainer>
              <IconButton
                className={circleButtonLeftClassName}
                size={32}
                icon={'caretLeft'}
                alt={t('left')}
              />
              <IconButton
                className={circleButtonRightClassName}
                size={32}
                icon={'caretRight'}
                alt={t('right')}
              />
            </SliderArrowsContainer>
          </HeroContainer>
          {!!segment.description?.length && (
            <Description>
              <TextClamp clamp={5}>{segment.description}</TextClamp>
            </Description>
          )}
          <SegmentCategoriesContainer>
            <Carousel
              buttonLeftClassName={circleButtonLeftClassName}
              buttonRightClassName={circleButtonRightClassName}
              slides={segmentCategories.map(category => (
                <CategorySlide
                  key={`segmentCategory-${segment.id}-${category.id}`}
                  category={category}
                />
              ))}
            />
          </SegmentCategoriesContainer>
        </OutletContainer>
      )}
    </>
  )
}
